(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-option"] && !Shopify.designMode) return;
  try {
    class CCardOption extends HTMLElement {
    connectedCallback() {
      this.addButton = this.querySelector('[data-btn-add]')
      this.addButtonContainer = this.querySelector('.card-option__content__add-button')
      this.inputContainer = this.querySelector('.card-option__content__price__input')
      this.input = this.querySelector('[data-product-option-quantity]')
      this.inputQuantity = this.querySelector('.card-option__content__price__input__value')
      this.plusButton = this.querySelector('[data-btn-plus]')
      this.minusButton = this.querySelector('[data-btn-minus]')
      this.iconMinus = this.querySelector('.icon-minus')
      this.iconTrash = this.querySelector('.icon-trash')
      this.priceOption = this.querySelector('[data-price-option]')
      this.optionInputs = this.querySelectorAll('input[type="hidden"]')

      // Nearest button with data-price attribute
      // get nearest panel container
      this.panelContainer = this.closest('c-panel')
      this.totalPriceInput = this.panelContainer.querySelector('[data-price]')

      // see more toggle
      this.description = this.querySelector('.card-option__description')
      this.toggle = this.querySelector('.card-option__toggle')

      if (this.description && this.toggle) {
        if (this.description.scrollHeight > this.description.clientHeight) {
          this.toggle.removeAttribute('hidden')
        }
        this.toggle.addEventListener('click', () => {
          const isExpanded = this.description.classList.toggle('is-expanded')
          this.toggle.classList.toggle('is-expanded', isExpanded)
        })
      }

      this.addButton?.addEventListener('click', () => this.incrementQuantity())
      this.plusButton?.addEventListener('click', () => this.incrementQuantity())
      this.minusButton?.addEventListener('click', () => this.decrementQuantity())
    }

    updatePrice(type) {
      if (!this.totalPriceInput || !this.priceOption) return
      const currentPrice = parseFloat(this.totalPriceInput.textContent)
      const optionPrice = this.priceOption.dataset.priceOption / 100
      if (type === 'increment') {
        this.totalPriceInput.textContent = currentPrice + optionPrice
      } else {
        this.totalPriceInput.textContent = currentPrice - optionPrice
      }
    }

    incrementQuantity() {
      this.input.value = parseInt(this.input.value, 10) + 1
      this.inputQuantity.textContent = this.input.value
      if (this.input.value > 0) {
        this.inputContainer.classList.remove('hidden')
        this.addButtonContainer.classList.add('hidden')
        this.optionInputs.forEach((i) => i.removeAttribute('disabled'))
      }
      if (this.input.value > 1) {
        this.iconMinus.classList.remove('hidden')
        this.iconTrash.classList.add('hidden')
      }
      this.updatePrice('increment')
    }

    decrementQuantity() {
      this.input.value = parseInt(this.input.value, 10) - 1
      this.inputQuantity.textContent = this.input.value
      if (this.input.value <= 0) {
        this.inputContainer.classList.add('hidden')
        this.addButtonContainer.classList.remove('hidden')
        this.optionInputs.forEach((i) => i.setAttribute('disabled', ''))
      }
      if (this.input.value <= 1) {
        this.iconMinus.classList.add('hidden')
        this.iconTrash.classList.remove('hidden')
      }
      this.updatePrice('decrement')
    }
  }

  if (!customElements.get('c-card-option')) {
    customElements.define('c-card-option', CCardOption)
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["input-textearea"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-textarea-field]').forEach((wrapper) => {
      const textarea = wrapper.querySelector('textarea')
      const charCount = wrapper.querySelector('.char-count')

      if (textarea && charCount) {
        const updateCounter = () => {
          const count = textarea.value.length
          charCount.textContent = String(count).padStart(3, '0')

          const maxLength = parseInt(textarea.getAttribute('maxlength'))
          const warningThreshold = maxLength * 0.9
          const criticalThreshold = maxLength * 0.8

          if (count > warningThreshold) {
            charCount.style.color = '#c00'
          } else if (count > criticalThreshold) {
            charCount.style.color = '#ff9800'
          } else {
            charCount.style.color = ''
          }
        }

        textarea.addEventListener('input', updateCounter)
        updateCounter() // Initialize
      }
    })
  })
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["localization"] && !Shopify.designMode) return;
  try {
    class LocalizationForm extends HTMLElement {
    constructor() {
      super()
      this.elements = {
        input: this.querySelector('input[name="language_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      }
      this.elements.button.addEventListener('click', this.openSelector.bind(this))
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this))
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this))

      this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)))
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false')
      this.elements.panel.setAttribute('hidden', true)
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return

      this.hidePanel()
      this.elements.button.focus()
    }

    onItemClick(event) {
      event.preventDefault()
      const form = this.querySelector('form')
      this.elements.input.value = event.currentTarget.dataset.value
      if (form) form.submit()
    }

    openSelector() {
      this.elements.button.focus()
      this.elements.panel.toggleAttribute('hidden')
      this.elements.button.setAttribute(
        'aria-expanded',
        (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
      )
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON'
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel()
      }
    }
  }

  customElements.define('localization-form', LocalizationForm)
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["messages-csv-hint"] && !Shopify.designMode) return;
  try {
    const MESSAGES_CSV_TEMPLATE = ['from,to,message', 'Marie Dupont,Jean Martin,Bon anniversaire'].join('\n')

  const MESSAGES_CSV_FILENAME = 'messages_exemple.csv'

  /**
   * @param {string} content
   * @param {string} filename
   */
  function downloadTextFile(content, filename) {
    const blob = new Blob([content], { type: 'text/csv;charset=utf-8' })
    const url = URL.createObjectURL(blob)
    const anchor = document.createElement('a')
    anchor.href = url
    anchor.download = filename
    anchor.click()
    URL.revokeObjectURL(url)
  }

  document.addEventListener('click', (event) => {
    const target = event.target
    if (!(target instanceof Element)) return
    const trigger = target.closest('[data-messages-csv-template-download]')
    if (!(trigger instanceof HTMLElement)) return
    event.preventDefault()
    downloadTextFile(MESSAGES_CSV_TEMPLATE, MESSAGES_CSV_FILENAME)
  })
  } catch(e) { console.error(e); }
})();

})();
